import { useHomeContextUser } from "../homeContext";
import { useCurrentVstLocale } from "../../../common/utils/locale";
import useJigsawUser from "../common/user/useJigsawUser";
import { useIntl } from "react-intl";
import ScrollableComponentTemplate from "../layout/content-templates/scrollable-component/ScrollableComponentTemplate.tsx";
import { isNative } from "common/utils/native.ts";

export default function GroupsComponent() {
  const user = useHomeContextUser();
  const jigsawUser = useJigsawUser();
  const vstLocale = useCurrentVstLocale();
  const intl = useIntl();
  const title = intl.formatMessage({ defaultMessage: "Groups" });

  return (
    <ScrollableComponentTemplate title={title}>
      {jigsawUser && (
        <rostering-groups
          isnative={isNative()}
          jigsawsessionid={jigsawUser.user.sessionId}
          lang={vstLocale}
          hasadmin={user.hasAdmin}
          hasgroups={user.hasGroups}
          omitbasename={true}
        />
      )}
    </ScrollableComponentTemplate>
  );
}
